const themeColor = {
  orange: "primary",
  blue: "blue3",
  green: "lightGreen4",
  black: "darkGreen1",
  darkGrey: "darkGrey",
};

export const setThemeColor = (val) => themeColor[val];

const contrastingThemeColor = {
  orange: "lightGreen3",
  black: "blue1",
  darkGrey: "lightBlue",
};

export const setContrastingThemeColor = (val) => contrastingThemeColor[val];
